<template>
  <div class="left-panel"
       :class="{'panelActive': this.selectedWeeks.length > 0 && this.deleteEvents}">
    <spinner v-if="isLoading"></spinner>
    <template v-else>
      <div v-show="lessons.length === 0">
        <h3>{{$t('vue2.copycalendar.noSubstitutesOrNotes')}}</h3>
      </div>
      <div v-show="lessons.length !== 0">
        <h2>{{$t('vue2.copycalendar.youAreAboutToDelete')}}</h2>
        <h4>{{lessons.length}} {{ lessons.length === 1 ? $t('vue2.copycalendar.lesson') : $t('vue2.copycalendar.lessons') }} {{ $t('vue2.copycalendar.withSubstitutesOrNotes')}}</h4>
        <hr>
      </div>
      <ul>
        <li v-for="(lesson, index) in sortedLesson" :key="lesson.id">
          <p class="headline" v-if="!isSameDate(index)">
            {{ $t('vue2.copycalendar.week') }} {{lesson.event_time_start | showWeek}}
          </p>
          <span class="icon-file-text2" v-if="lesson.has_notes"></span>
          <span class="icon-users" v-if="lesson.has_substitute"></span>
          {{lesson.event_time_start | showDateAndTime}}
          {{lesson.title}}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
  import spinner from '../common/Spinner.vue'
  import docendo from '../../docendo' // eslint-disable-line no-unused-vars
  import moment from 'moment' // eslint-disable-line no-unused-vars

  export default {
    components: {spinner},
    props: ['selectedWeeks', 'calId', 'deleteEvents'],
    watch: {
      selectedWeeks (val, oldVal) {
        this.checkForNotesAndSubstitutes(val)
      },
      isLoading (val, oldVal) {
        this.$emit('load', val)
      },
      deleteEvents (val, oldVal) {
        if (val) {
          this.checkForNotesAndSubstitutes(this.selectedWeeks)
        }
      }
    },
    data () {
      return {
        isLoading: false,
        lessons: []
      }
    },
    computed: {
      sortedLesson () {
        return this.lessons.sort(function compare (a, b) {
          var dateA = new Date(a.event_time_start)
          var dateB = new Date(b.event_time_start)
          return dateA - dateB
        })
      }
    },
    filters: {
      showDateAndTime (val) {
        return moment(val).format('lll')
      },
      showWeek (date) {
        return moment(date).isoWeek()
      }
    },
    methods: {
      checkForNotesAndSubstitutes (weekNums) {
        if (!this.deleteEvents) {
          return
        }
        var spinnerTimer = setTimeout(() => {
          this.isLoading = true
        }, 100)
        this.lesson = []
        docendo.calendarCopyCheck(this.calId, this.selectedWeeks, data => {
          clearTimeout(spinnerTimer)
          this.isLoading = false
          this.lessons = data
        })
      },
      isSameDate (index) {
        if (index > 0) {
          let l1 = this.sortedLesson[index].event_time_start
          let l2 = this.sortedLesson[index - 1].event_time_start
          return moment(l1).isoWeek() === moment(l2).isoWeek()
        } else {
          return false
        }
      }
    },
    beforeMount () {
      if (this.selectedWeeks.length > 0) {
        this.checkForNotesAndSubstitutes(this.selectedWeeks)
      }
    }
  }
</script>

<style>
  @import '../../assets/css/variables.css';

  .left-panel {
    position: absolute;
    z-index: 0;
    left: 0px;
    top: 0;
    width: 285px;
    height: 100%;
    background: var(--blue);
    color: #ffffff;
    padding: 15px;
    transition: all 0.3s;
    overflow-y: auto;
  }

  .left-panel.panelActive {
    transform: translateX(-285px);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .21);
  }

  .headline {
    font-size: 14px;
    font-weight: bold;
    color: var(--dark-blue);
    margin: 5px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// Feedback.vue?0a53788c